import { authHandlers } from './auth';

export const handlers = [...authHandlers];
